import { cn } from '~/lib/cn';
import {
  InternalLinkItem,
  type InternalLinkItemProps,
} from '~/modules/link-farm/components/LinkList/InternalLinkItem';
import type { LinkItemProps } from '~/modules/link-farm/components/LinkList/LinkItem.tsx';
import { LinkItem } from '~/modules/link-farm/components/LinkList/LinkItem.tsx';

import type { InternalLinkType } from '../../types';

interface LinkListProps {
  data: (LinkItemProps | InternalLinkItemProps)[];
  onInternalLinkClick?: (
    event: React.MouseEvent<HTMLAnchorElement>,
    type?: InternalLinkType,
  ) => void;
  className?: string;
}

export function LinkList({
  data,
  onInternalLinkClick,
  className,
}: LinkListProps) {
  return (
    <div
      className={cn(
        'grid gap-md',
        'auto-cols-[277px] grid-cols-[repeat(auto-fit,277px)]',
        'auto-rows-[184px] grid-rows-[repeat(auto-fit,minmax(184px,1fr))]',
        className,
      )}
    >
      {data.map((item) => {
        const isInternal = 'previewImgSrc' in item;

        return isInternal ? (
          <InternalLinkItem
            key={item.actionTextKey}
            {...item}
            onClick={onInternalLinkClick}
          />
        ) : (
          <LinkItem key={item.actionText + item.url} {...item} />
        );
      })}
    </div>
  );
}

LinkList.displayName = 'LinkList';
